<template>
  <div class="menu">
    <el-menu
      class="el-menu-vertical-demo"
      unique-opened
      :default-active="activeIndex"
      @open="handleOpen"
      @close="handleClose"
      @select="handleSelect"
      router
    >
      <el-menu-item index="/home">
        <template slot="title">
          <span>首页</span>
        </template>
      </el-menu-item>
      <el-submenu index="/mercury-project">
        <template slot="title">
          <span>水星计划</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/mercury-project/about">关于水星计划</el-menu-item>
          <el-menu-item index="/mercury-project/service">开发服务</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="3">
        <template slot="title">
          <span>生物制造工艺</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="3-1" @click="toMolecule('Combo-E')">Combo-E</el-menu-item>
          <el-menu-item index="3-2" @click="toMolecule('Combo-Q')">Combo-Q</el-menu-item>
          <el-menu-item index="3-3" @click="toMolecule('Combo-G')">Combo-G</el-menu-item>
          <el-menu-item index="3-4" @click="toMolecule('Combo-M')">Combo-M</el-menu-item>
          <el-menu-item index="3-5" @click="toMolecule('Flex-SC')">Flex-SC</el-menu-item>
          <el-menu-item index="3-6" @click="toMolecule('Flex-CG')">Flex-CG</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="4">
        <template slot="title">
          <span>实验与诊断智能</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="4-1" @click="biology_1">ACE Line</el-menu-item>
          <el-menu-item index="4-2" @click="biology_2">Lib Master</el-menu-item>
          <el-menu-item index="/bioengineering-technology" @click="biology_3">Gemini</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="/about">
        <template slot="title">
          <span>关于我们</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/about/about-introduce">公司介绍</el-menu-item>
          <!-- <el-menu-item index="/about/carousel">媒体报道</el-menu-item> -->
          <el-menu-item index="/about/about-connect">联系我们</el-menu-item>
          <el-menu-item index="/about/about-join">加入合木</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
    <div class="btn_space">
      <!-- <CommonDialog :dialogFormVisible.sync="Visible" /> -->
      <el-button type="primary" @click="dialogClick" class="btn">联系销售</el-button>
    </div>
    <!-- <div class="cover"></div> -->
  </div>
</template>
<script>
import $ from 'jquery';

export default {
  name: 'index',
  components: {
    CommonDialog: () => import('../../pc/dialog/index.vue')
  },
  data() {
    return {
      activeIndex: '/home',
      Visible: false
    };
  },
  methods: {
    changeIndex(value) {
      this.activeIndex = value;
      console.log('changeIndex', value);
    },
    biology_1() {
      this.$router.push({ path: '/bioengineering-technology', query: { name: 'ACE Line' } });
      console.log(hide);
    },
    biology_2() {
      this.$router.push({ path: '/bioengineering-technology', query: { name: 'Lib Master' } });
    },
    biology_3() {
      this.$router.push({ path: '/bioengineering-technology', query: { name: 'Gemini' } });
    },
    toMolecule(text) {
      this.$router.push({ path: '/bioengineering-technology', query: { name: text } });
    },

    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelect(key) {
      this.$emit('handle', true);
      this.activeIndex = key;
    },
    close() {
      $('.fixed-nav').fadeOut();
    },
    dialogClick() {
      this.$router.push({ path: '/about/contact', query: { name: 'contract' } });
      this.$emit('handle', true);
    }
  },
  mounted() {
    this.activeIndex = window.location.pathname;
  }
};
</script>
<style lang="less" scoped>
.cover {
  border-radius: 8px;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #081630;
  opacity: 0.8;
}
// /deep/ .el-menu-item,
// .el-submenu__title {
//   font-weight: 600;
//   height: 48px;
//   line-height: 48px;
//   list-style: none;
//   font-size: 32px;
//   margin-bottom: 40px;
// }
// /deep/ .el-submenu__title {
//   height: 48px;
//   line-height: 48px;
//   font-size: 32px;
//   margin-bottom: 20px;
//   font-weight: 600;
// }
// /deep/ .is-opened {
//   .el-submenu__title {
//     font-size: 24px;
//     margin-bottom: 0 !important;
//     font-weight: 500;
//     color: #5b6880;
//   }
//   .el-menu-item {
//     margin-bottom: 0px !important;
//   }
// }

// /deep/ .el-submenu__title {
//   font-family: 'PingFang SC';
//   font-style: normal;
//   font-weight: 500;
//   font-size: 24px;
//   line-height: 28px;
//   color: #5b6880;
// }

// /deep/ ul > li .el-menu-item {
//   font-family: 'PingFang SC';
//   font-style: normal;
//   font-weight: 600;
//   font-size: 32px;
//   color: #112448;
// }
// /deep/ .el-menu {
//   border-right: none;
// }

// /deep/ .el-menu-item {
//   margin-bottom: 40px;
// }

// /deep/ .el-menu-item > span {
//   font-family: 'PingFang SC';
//   font-style: normal;
//   font-weight: 600;
//   font-size: 32px;
//   line-height: 48px;
//   text-align: center;
//   color: #112448;
// }

// /deep/ .el-menu-item is-active {
//   font-family: 'PingFang SC';
//   font-style: normal;
//   font-weight: 500;
//   font-size: 24px;
//   line-height: 28px;
//   text-align: center;
//   color: #5b6880;
// }

// /deep/.el-submenu__icon-arrow {
//   top: 35%;
// }
// /deep/ .el-menu-item-group ul {
//   margin-left: -20px;
//   margin-top: 10px;
// }
// /deep/ .el-submenu .el-submenu__title {
//   margin-bottom: 40px;
//   height: 40px;
//   padding-left: 20px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// }
// /deep/ .el-menu-item-group__title {
//   margin-top: -40px;
//   margin-bottom: 10px;
// }

// /deep/ .el-menu-item-group > ul .el-menu-item {
//   margin-bottom: 40px;
// }
.font_h1 {
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  color: #5b6880;
}
.font_h2 {
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  color: #112448;
}
.menu {
  overflow: auto;
  position: fixed;
  width: 100%;
  top: 120px;
  text-align: center;
  padding-top: 48px;
  background: #fff;
  .menu_list {
    width: 100%;
    height: 100%;
    background: #fff;
    padding-top: 48px;

    ul {
      text-align: center;
    }
  }
  .btn_space {
    display: flex;
    justify-content: center;
    height: 240px;
    .btn {
      margin: 40px;
      height: 72px;
      width: 620px;
      background: #009aef;
      border-radius: 4px;
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 500;
      font-size: 32px;
      line-height: 40px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/mobile/components/navbar-menu.vue